// A player's habits, fitted from their archived wars by
// scripts/fit-player-model.js — regenerate rather than edit.

const PLAYER_MODEL = {
    "fittedFrom": [
        "1788991502842",
        "1789000682842",
        "1789003590736",
        "1789005202138",
        "1789007297908",
        "1789520998339",
        "1789522117676",
        "1790018345905",
        "1790019975121",
        "1790020886508",
        "1790039225924",
        "1790381112956",
        "1790616690775",
        "1790632652941",
        "1790635425364",
        "1790645161557",
        "1790651487321",
        "1790697545176",
        "1790703299836",
        "1790799346772",
        "1790816340152",
        "1790817621795",
        "1790835608074",
        "1790836427387",
        "1790837966600",
        "1790838828358",
        "1790880969981",
        "1790882872145",
        "1790884556823",
        "1790887736138",
        "1790889041038",
        "1790890550493",
        "1790895030474",
        "1790895799293",
        "1790903962718",
        "1790907184648",
        "1790908550184",
        "1790912504229",
        "1790913707065",
        "1790914444769",
        "1790920713980",
        "1790967912716",
        "1790970654874",
        "1790971952204",
        "1790972796728",
        "1790973773026",
        "1790974247029",
        "1790974840466",
        "1790975393305",
        "1790975733053",
        "1790976569672",
        "1790977485009",
        "1790982319527",
        "1790986085419",
        "1790987304508",
        "1790988470484",
        "1790991191249",
        "1790992334499",
        "1790993198596",
        "1790994510491",
        "1790995252089",
        "1790995882018",
        "1790996585459",
        "1790997270292",
        "1791000513510",
        "1791001054706",
        "1791002156281",
        "1791003215762",
        "1791004156416",
        "1791004644403",
        "1791005275540",
        "1791006664461",
        "1791007273476",
        "1791007730544",
        "1791008047077",
        "1791008673528",
        "1791009093880",
        "1791009617267",
        "1791010080597",
        "1791010903233",
        "1791011040951",
        "1791012139941",
        "1791013703507",
        "1791014823126",
        "1791015653257",
        "1791016242344",
        "1791041613581",
        "1791070030168",
        "1791073231716",
        "1791074140866",
        "1791092531019",
        "1791147841127",
        "1791151053938",
        "1791156505577",
        "1791158421709",
        "1791162605567",
        "1791164517089",
        "1791174527620",
        "1791175045787",
        "1791175987156",
        "1791225551413",
        "1791227780518",
        "1791231044473",
        "1791231671315",
        "1791254061598",
        "1791259107187",
        "1791333769815",
        "1791337528919",
        "1791511114599",
        "1791517066287",
        "1791517735335",
        "1791518604043",
        "1791519975627",
        "1791520259611",
        "1791522937333",
        "1791523724309",
        "1791524697898",
        "1791525298222",
        "1791526664317",
        "1791527782908",
        "1791529251771",
        "1791531128265",
        "1791532497036",
        "1791533207408",
        "1791535439466",
        "1791537165620",
        "1791538097035",
        "1791539418440",
        "1791540455725",
        "1791541569894",
        "1791585424956",
        "1791690759728",
        "1791920563062",
        "1791933755893",
        "1791934377979",
        "1791934452370",
        "1791955222092",
        "1791958067714",
        "1791962761139",
        "1791965755632",
        "1792006517126",
        "1792024678681",
        "1792025852128",
        "1792027260735",
        "1792029551033",
        "1792031784276",
        "1792032576769",
        "1792033835546",
        "1792034573576",
        "1792034846897",
        "1792035174649",
        "1792035817900",
        "1792038413994",
        "1792038694536",
        "1792040000143",
        "1792041902993",
        "1792041987801",
        "1792043569946",
        "1792045912126",
        "1792047136689",
        "1792048533627",
        "1792050133457",
        "1792078979519",
        "1792083044067",
        "1792085044105",
        "1792098101727",
        "1792103069912",
        "1792106242577",
        "1792177525488",
        "1792179052706",
        "1792182944293",
        "1792188411754",
        "1792207274225",
        "1792275653315",
        "1792276621625",
        "1792277665171",
        "1792299195302",
        "1792339804391",
        "1792441297599",
        "1792452743657",
        "1792478052934",
        "1792479412897",
        "1792480918723",
        "1792482833946",
        "1792484657440",
        "1792485472220",
        "1792644408220",
        "1792786598720",
        "1792788204157",
        "1792801037069",
        "1792802030310",
        "1792811131565",
        "1792980398204"
    ],
    "heldOut": [
        "1792177525488",
        "1792179052706",
        "1792182944293",
        "1792188411754",
        "1792207274225",
        "1792275653315",
        "1792276621625",
        "1792277665171",
        "1792299195302",
        "1792339804391",
        "1792441297599",
        "1792452743657",
        "1792478052934",
        "1792479412897",
        "1792480918723",
        "1792482833946",
        "1792484657440",
        "1792485472220",
        "1792644408220",
        "1792786598720",
        "1792788204157",
        "1792801037069",
        "1792802030310",
        "1792811131565",
        "1792980398204"
    ],
    "holdoutCheck": {
        "decisions": 1101,
        "logLikelihood": -0.39906969555551364,
        "randomBotLogLikelihood": -0.6368411141333713,
        "accuracy": 0.8356039963669392
    },
    "attackByEdge": {
        "0": 0.08328230251071647,
        "-2": 0.047058823529411764,
        "-1": 0.08681672025723473,
        "+1": 0.29820936639118456,
        "+2": 0.5460455037919827,
        "+3": 0.7083333333333334
    },
    "attackByTarget": {
        "known": {
            "+1": 0.3512517050469389,
            "+2": 0.5847573922482949
        },
        "stamps": {
            "+1": 0.27651780038143675,
            "+2": 0.6373699584892123
        },
        "none": {
            "+1": 0.26592781885844086,
            "+2": 0.5149251333461861
        }
    },
    "attackFromBroodCorridor": 0.20975399223133362,
    "attackFromBroodCorridorByEdge": {
        "0": 0.0972996449335021,
        "+1": 0.2091561876268414,
        "+2": 0.31009337909378554
    },
    "attackFromBroodCorridorByTarget": {
        "known": {
            "+1": 0.3296810643419659,
            "+2": 0.4204512449297883
        },
        "stamps": {
            "+1": 0.17099218474824301,
            "+2": 0.24385234482603196
        },
        "none": {
            "+1": 0.14225840388193464,
            "+2": 0.1834069196609803
        }
    },
    "deployWeight": {
        "threatened": 0.5386439374519354,
        "brood": 0.16297662976629768,
        "stack": 0.16922060766182298,
        "empty": 0.16186491848529286
    },
    "broodWhenAble": 0.3533501896333755,
    "moveWhenAble": 0.20569436374201047,
    "rocketWhenAffordable": 0.014046216583597644,
    "planeWhenAffordable": 0.018589968432129077,
    "counts": {
        "attackDecisions": {
            "0": 1631,
            "-2": 508,
            "-1": 620,
            "+1": 1450,
            "+2": 921,
            "+3": 310
        },
        "attackByTargetDecisions": {
            "known": {
                "+1": 512,
                "+2": 590
            },
            "stamps": {
                "+1": 257,
                "+2": 392
            },
            "none": {
                "+1": 681,
                "+2": 249
            }
        },
        "broodCorridorDecisions": 2315,
        "broodCorridorByEdge": {
            "0": 949,
            "+1": 306,
            "+2": 1060
        },
        "broodCorridorByTarget": {
            "known": {
                "+1": 99,
                "+2": 463
            },
            "stamps": {
                "+1": 65,
                "+2": 415
            },
            "none": {
                "+1": 142,
                "+2": 182
            }
        },
        "deploys": {
            "threatened": 4202,
            "brood": 132,
            "stack": 640,
            "empty": 1876
        }
    }
}

export default PLAYER_MODEL
